import React from 'react'

const React_Coding_Practice_11 = () => {
  return (
    <div>
      <h1>Coding Pratice 11</h1>
    </div>
  )
}

export default React_Coding_Practice_11
